module.exports = __webpack_public_path__ + "img/white-footer-2.a05ade58.png";